import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'workflowNotificationMyProgressList',
    initialState: {
        isRequesting: false,
        error: null,
        data: [],
        total: 0,
        hasMore: false,
        total_unread:0,
        searchCriteria:{}
    },
    reducers: {
        get_list: (state,action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria:{...action.payload}
            };
        },
        get_list_succeed: (state, action) => {
            if (state.searchCriteria.page === 1)
            {return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.data.notifications,
                total: action.payload.total,
                hasMore: action.payload.data.more,
                total_unread:action.payload.total_unread || 0,
            };}
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: [...state.data,...action.payload.data.notifications],
                total: action.payload.total,
                hasMore: action.payload.data.more,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: []
            };
        },
        mark_read:(state) => {
            return {
                ...state
            };
        }, 
        mark_read_succeed:(state,action) => {
            if (action.payload !== 'all')
            {
                return {
                    ...state,
                    total_unread:state.total_unread - 1,
                    data:state.data.map(i=>{    
                        if (i.id === action.payload)
                        {
                            return ({
                                ...i,
                                read:true,
                            });
                        }
                        return i;
                    })
                };
            }

            return {
                ...state,
                total_unread: 0,
                data: state.data.map(i=>{    
                    return {
                        ...i,
                        read: true,
                    };
                })
            };
        }
    }
});

export const {reducer, actions} = slice;

export default reducer;